type DotIconProps = {
  className?: string;
  fill: string;
};

const Dot = ({ fill, className }: DotIconProps) => {
  return (
    <svg
      className={className}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="12" height="12" rx="6" fill={fill ? fill : '#DE5353'} fillOpacity="0.2" />
      <rect x="3" y="3" width="6" height="6" rx="3" fill={fill ? fill : '#DE5353'} />
    </svg>
  );
};

export default Dot;
